import { render, staticRenderFns } from "./component.vue?vue&type=template&id=737d1fe5&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('737d1fe5')) {
      api.createRecord('737d1fe5', component.options)
    } else {
      api.reload('737d1fe5', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=737d1fe5&", function () {
      api.rerender('737d1fe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-scrollbar/component.vue"
export default component.exports